module.exports = require("cli-color");


/*****************
 ** WEBPACK FOOTER
 ** external "cli-color"
 ** module id = 17
 ** module chunks = 0
 **/